/* eslint-disable */
import { GetterTree } from "vuex";
import { Alert } from "@/models/alert";
import { Pagination } from "@/models/pagination";
import { RootState } from "@/types";
import { AlertState } from "@/types/alert";

const getters: GetterTree<AlertState, RootState> = {
  list: (state) => {
    return state.pagination ? state.pagination.data : [];
  },
  pagination: (state) => {
    return state.pagination || new Pagination();
  },
  single: (state) => {
    return state.single || new Alert();
  },
  find: (state) => (id: number) => {
    return state.pagination
      ? state.pagination.data.find((alert) => {
          return alert.id == id;
        })
      : new Alert();
  },
  selectItem: (state) => {
    return state.pagination
      ? state.pagination.data.map((alert) => Alert.toSelectItem(alert))
      : [];
  },
};

export default getters;
